import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import * as S from './styles';

interface ICountControlProps {
  initialCount?: number;
  maxCount?: number;
  isBlocked?: boolean;
  removeArrow?: boolean;
  onIncrement?: (count: number) => Promise<void> | void;
  onDecrement?: (count: number) => Promise<void> | void;
  customMargin?: string;
}
function CountControl({
  initialCount = 0,
  maxCount = 99,
  isBlocked = false,
  removeArrow = false,
  onIncrement = () => { },
  onDecrement = () => { },
  customMargin = '0 auto'
}: ICountControlProps) {
  const [count, setCount] = useState(initialCount);

  async function handleDecrement(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    if (count > 0) {
      try {
        const updatedCount = count - 1;
        setCount(prev => prev - 1);
        await onDecrement(updatedCount);
      } catch (error) {
        setCount(prev => prev + 1);
        if (error instanceof Error) toast.error(error.message);
      }
    }
  }
  async function handleIncrement(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    try {
      const updatedCount = count + 1
      setCount(prev => prev + 1)
      await onIncrement(updatedCount)
    } catch (error) {
      setCount(prev => prev - 1)
      if (error instanceof Error) toast.error(error.message)
    }
  }
  function handleClickContainer(e: React.MouseEvent<HTMLDivElement>) {
    e.stopPropagation();
  }

  useEffect(() => {
    setCount(initialCount)
  }, [initialCount])

  return (
    <S.Container customMargin={customMargin} onClick={handleClickContainer} id='id-register-btnIcon-ArrowBase'>
      {!removeArrow && (
        <S.ArrowLeft onClick={handleDecrement} disabled={count <= 1 || isBlocked} id='id-register-btnIcon-ArrowLeft'>
          <ArrowForwardIosIcon fontSize='small' />
        </S.ArrowLeft>
      )}
      <S.Count $isRemoveArrow={removeArrow}>{count}</S.Count>
      {!removeArrow && (
        <S.ArrowRight onClick={handleIncrement} disabled={count >= maxCount || isBlocked} id='id-register-btnIcon-ArrowRight'>
          <ArrowForwardIosIcon fontSize='small' />
        </S.ArrowRight>
      )}
    </S.Container>
  )
}

export default CountControl